import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

export const getDashboardData = async () => { 
    try {
        const response = await axios.get(`${API_BASE_URL}/api/students/dashboard`, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json', 
                'Authorization': `Bearer ${JSON.parse(localStorage.getItem('pocketbase_auth')).token}`
            }
        });
        
        return response.data;
    } catch (error) {
        console.error("Error fetching dashboard data:", error);
        throw error;
    }
};

export const getStudentStats = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/api/students/stats`, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json', 
                'Authorization': `Bearer ${JSON.parse(localStorage.getItem('pocketbase_auth')).token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching student stats:", error);
        throw error;
    }
};

export const getProspectStatus = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/api/prospects/status`, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json', 
                'Authorization': `Bearer ${JSON.parse(localStorage.getItem('pocketbase_auth')).token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching prospect status:", error);
        throw error;
    }
};

export const getTopFormations = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/api/students/top-formations`, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json', 
                'Authorization': `Bearer ${JSON.parse(localStorage.getItem('pocketbase_auth')).token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching top formations:", error);
        throw error;
    }
};

export const getStudentContractStatus = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/api/students/contract-status`, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json', 
                'Authorization': `Bearer ${JSON.parse(localStorage.getItem('pocketbase_auth')).token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching student contract status:", error);
        throw error;
    }
};

export const getRuptureStats = async () => { 
    try {
        const response = await axios.get(`${API_BASE_URL}/api/stats/rupture`, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json', 
                'Authorization': `Bearer ${JSON.parse(localStorage.getItem('pocketbase_auth')).token}`  
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching rupture stats:", error);
        throw error;
    }
};

export const getDashboardAdminData = async () => { 
    try {
        const response = await axios.get(`${API_BASE_URL}/api/admin/dashboard`, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json', 
                'Authorization': `Bearer ${JSON.parse(localStorage.getItem('pocketbase_auth')).token}`  
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching dashboard admin data:", error);
        throw error;
    }
};

export const getDemoAccountStats = async () => { 
    try {
        const response = await axios.get(`${API_BASE_URL}/api/admin/demo-stats`, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json', 
                'Authorization': `Bearer ${JSON.parse(localStorage.getItem('pocketbase_auth')).token}`  
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching demo account stats:", error);
        throw error;
    }
};